import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

// Non-bureau event invitations: list() = Invitation Log, create() = Send,
// update({ id: 'html'|'print'|'email', ... }) = per-channel template selection,
// getSelection() = the event's currently selected template ids.
@Injectable()
export class CoreEventInvitationService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/invitations`);
  }

  getSelection(urlParams: any = {}, apiParams: any = {}): Observable<any> {
    const url = sprintf(`${this.baseUrl}/all`, urlParams);
    return this.http.get<any>(url, {
      params: this.toHttpParams(apiParams),
    });
  }
}
